import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=2a30146a&scoped=true"
import script from "./ExchangeRate.vue?vue&type=script&lang=js"
export * from "./ExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRate.vue?vue&type=style&index=0&id=2a30146a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a30146a",
  null
  
)

export default component.exports